import React from 'react';

import { HorizontalArrow, VerticalArrow } from './components';

interface BranchArrowProps {
  hasNext?: boolean;
}
export const BranchArrow = (props: BranchArrowProps) => {
  const { hasNext } = props;

  return (
    <>
      <VerticalArrow $length="40px" $hasNext={hasNext} />
      <HorizontalArrow />
    </>
  );
};
